const C = {
  name: "Store",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.82614 3.34965C4.1021 2.56121 4.85181 2 5.72 2H18.28C19.1367 2 19.8978 2.54109 20.1763 3.35686L20.1789 3.3643L22 8.83801V10C22 11.4833 21.1964 12.7757 20 13.4664V20H22V22H2V20H4V13.4664C2.80361 12.7757 2 11.4833 2 10V8.83801L3.82358 3.35696L3.82614 3.34965ZM18 20V14C16.8042 14 15.7324 13.4777 15 12.6483C14.2676 13.4777 13.1958 14 12 14C10.8042 14 9.73243 13.4777 9 12.6483C8.26757 13.4777 7.19581 14 6 14V20H18ZM10 10C10 11.1077 10.8923 12 12 12C13.1077 12 14 11.1077 14 10H10ZM18 12C19.1077 12 20 11.1077 20 10H16C16 11.1077 16.8923 12 18 12ZM18.2833 4.00206L18.2824 4.00017L18.28 4H15.1805L15.8472 8H19.6134L18.2833 4.00206ZM13.1529 4H10.8472L10.1805 8H13.8196L13.1529 4ZM8.81961 4H5.72278L5.72152 4.00084C5.71785 4.00349 5.71557 4.00669 5.71444 4.00899L4.3866 8H8.15294L8.81961 4ZM6 12C7.10772 12 8 11.1077 8 10H4C4 11.1077 4.89228 12 6 12Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Store
};
